import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import {toast} from "react-toastify";
import {Checkbox} from 'primereact/checkbox';
import DepartmentService from "../../shared/service/DepartmentService";
import TaxService from "../../shared/service/TaxService";
import Dialog from "../../shared/component/dialog/Dialog";
import DepartmentTransfer from "./DepartmentTransfer";
import {PRICE_CALCULATION_METHOD} from "../../shared/utils/Constants";
import '../../shared/styles/SettingsPage.css';

const defaultDepartment = {
    id: '',
    name: '',
    status: 'ACTIVE',
    tax: null,
    ageRestricted: false,
    excludePromotion: false,
    shelfEdgeLabelRequired: false,
    excludeServiceCharge: false,
    autoCreateMenu: false,
    profitMargin: null,
    sectionNo: null
};

export default class DepartmentSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            department: defaultDepartment,
            departmentTemp: defaultDepartment,
            departmentDetailsSaveButtonRender: true,
            defaultStatus: 'ACTIVE',
            taxList: [],
            departmentList: []
        }
        this.departmentService = new DepartmentService();
        this.taxService = new TaxService();
    }

    componentDidMount() {
        let id = window.location.href.split('?')[1];
        if (!GeneralUtils.__isValueEmpty(id)) {
            this.departmentService.findById(id).then(response => {
                this.setState({
                    department: response,
                    departmentDetailsSaveButtonRender: false,
                    departmentTemp: Object.assign({}, response)
                });
            });
        } else {
            let obj1 = Object.assign({}, defaultDepartment);
            this.setState({
                department: obj1,
                departmentDetailsSaveButtonRender: true,
                departmentTemp: Object.assign({}, obj1)
            });
        }

        this.taxService.findAll().then(response => this.setState({taxList: response}));
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    {this.departmentDetails()}
                </AvForm>
            </div>
        );
    }

    setChecked = (name, value) => {
        let department = this.state.department;
        if (name == "excludePromotion" && value == true) {
            this.departmentService.hasConnectedAnyMixAndMatch(this.state.department.id).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    department[name] = value;
                    this.setState({department: department});
                }
            });
        } else {
            department[name] = value;
            this.setState({department: department});
        }
    }

    departmentDetails() {
        return (
            <div className="settings-page__shell">
                <div className="settings-page__header">
                    <h1 className="settings-page__title">Department Details</h1>
                </div>

                <div className="settings-page__panel">
                    <Dialog
                        visible={this.state.displayDialog}
                        header={""}
                        onHide={() => this.setState({displayDialog: false})}
                        style={GeneralUtils.getDialogStyleMerchantForDialog()}>
                        <DepartmentTransfer
                            ref={(elem) => this.refModelSave = elem}
                            closeDisplayDialog={this.closeDisplayDialog}/>
                    </Dialog>

                    <div className="settings-page__filter settings-page__filter--form">
                        <div className="settings-page__filter-row settings-page__filter-row--cols-4 settings-page__filter-row--wide settings-page__form-fields">
                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="department-name">
                                        <Translate contentKey="department.tradingName">Name</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <AvField
                                        id="department-name"
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        disabled={!this.state.departmentDetailsSaveButtonRender}
                                        validate={{
                                            maxLength: {
                                                value: 255,
                                                errorMessage: "You can enter up to 255 characters in this field."
                                            }
                                        }}
                                        value={this.state.department.name}
                                        onChange={this.__handleChange}/>
                                </AvGroup>
                            </div>

                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="department-section-no">
                                        <Translate contentKey="contactManagement.mobilePhone">Section No</Translate>
                                    </Label>
                                    <AvField
                                        id="department-section-no"
                                        type="number"
                                        disabled={!this.state.departmentDetailsSaveButtonRender}
                                        className="form-control"
                                        name="sectionNo"
                                        value={this.state.department.sectionNo}
                                        onChange={this.__handleChange}/>
                                </AvGroup>
                            </div>

                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="department-tax">
                                        <Translate contentKey="contactManagement.mobilePhone">Tax</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <AvField
                                        id="department-tax"
                                        type="select"
                                        disabled={!this.state.departmentDetailsSaveButtonRender}
                                        className="form-control"
                                        name="tax"
                                        value={this.state.department.tax}
                                        onChange={this.__handleChange}>
                                        <option value='' key=''/>
                                        {this.state.taxList.map(element => (
                                            <option value={element.id} key={element.id}>
                                                {element.name}
                                            </option>
                                        ))}
                                    </AvField>
                                </AvGroup>
                            </div>

                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="department-profit-margin">
                                        <Translate contentKey="contactManagement.mobilePhone">Profit Margin</Translate>
                                    </Label>
                                    <AvField
                                        id="department-profit-margin"
                                        type="number"
                                        disabled={!this.state.departmentDetailsSaveButtonRender}
                                        className="form-control"
                                        name="profitMargin"
                                        value={this.state.department.profitMargin}
                                        onChange={this.__handleChange}/>
                                </AvGroup>
                            </div>
                        </div>

                        <div className="settings-page__options settings-page__options--department-row">
                            <div className="settings-page__option">
                                <Checkbox
                                    onChange={(e) => this.setChecked("ageRestricted", e.checked)}
                                    name="ageRestricted"
                                    disabled={!this.state.departmentDetailsSaveButtonRender}
                                    value={this.state.department.ageRestricted}
                                    checked={this.state.department.ageRestricted}/>
                                <Label for="ageRestricted" className="settings-page__option-label">
                                    <Translate contentKey="department.firstName">Age Restricted?</Translate>
                                </Label>
                            </div>

                            <div className="settings-page__option">
                                <Checkbox
                                    onChange={(e) => this.setChecked("excludePromotion", e.checked)}
                                    name="excludePromotion"
                                    disabled={!this.state.departmentDetailsSaveButtonRender}
                                    value={this.state.department.excludePromotion}
                                    checked={this.state.department.excludePromotion}/>
                                <Label for="excludePromotion" className="settings-page__option-label">
                                    <Translate contentKey="department.lastName">Exclude Promotion?</Translate>
                                </Label>
                            </div>

                            <div className="settings-page__option">
                                <Checkbox
                                    onChange={(e) => this.setChecked("shelfEdgeLabelRequired", e.checked)}
                                    name="shelfEdgeLabelRequired"
                                    disabled={!this.state.departmentDetailsSaveButtonRender}
                                    value={this.state.department.shelfEdgeLabelRequired}
                                    checked={this.state.department.shelfEdgeLabelRequired}/>
                                <Label for="shelfEdgeLabelRequired" className="settings-page__option-label">
                                    <Translate contentKey="department.emailAddress">Shelf Edge Label Required?</Translate>
                                </Label>
                            </div>

                            <div className="settings-page__option">
                                <Checkbox
                                    onChange={(e) => this.setChecked("excludeServiceCharge", e.checked)}
                                    name="excludeServiceCharge"
                                    disabled={!this.state.departmentDetailsSaveButtonRender}
                                    value={this.state.department.excludeServiceCharge}
                                    checked={this.state.department.excludeServiceCharge}/>
                                <Label for="excludeServiceCharge" className="settings-page__option-label">
                                    <Translate contentKey="department.companyNo">Exclude Service Charge?</Translate>
                                </Label>
                            </div>

                            <div className="settings-page__option">
                                <Checkbox
                                    onChange={(e) => this.setChecked("autoCreateMenu", e.checked)}
                                    name="autoCreateMenu"
                                    disabled={!this.state.departmentDetailsSaveButtonRender}
                                    value={this.state.department.autoCreateMenu}
                                    checked={this.state.department.autoCreateMenu}/>
                                <Label for="autoCreateMenu" className="settings-page__option-label">
                                    <Translate contentKey="department.autoCreateMenu">Auto Create Menu?</Translate>
                                </Label>
                            </div>

                            <p className="settings-page__notice">
                                <Translate contentKey="contactManagement.mobilePhone">Warning! Products which are
                                    connected to this department will not queue for shelf edge label</Translate>
                            </p>
                        </div>

                        <div className="settings-page__filter-row settings-page__filter-row--cols-4 settings-page__filter-row--wide settings-page__form-fields" style={{marginTop: '0.75rem'}}>
                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="price-calculation-method">
                                        <Translate contentKey="merchantAccount.emailAddress">Calculation Method</Translate>
                                    </Label>
                                    <AvField
                                        id="price-calculation-method"
                                        type="select"
                                        className="form-control"
                                        name="priceCalculationMethod"
                                        disabled={!this.state.departmentDetailsSaveButtonRender}
                                        value={this.state.department.priceCalculationMethod}
                                        onChange={this.__handleChange}>
                                        {PRICE_CALCULATION_METHOD.map(element => (
                                            <option value={element.value} key={element.value}>
                                                {element.name}
                                            </option>
                                        ))}
                                    </AvField>
                                </AvGroup>
                            </div>

                            <div className="settings-page__filter-field">
                                <AvGroup>
                                    <Label for="price-calculation-rate">
                                        <Translate contentKey="productfirstName">Calculation Rate</Translate>
                                    </Label>
                                    <AvField
                                        id="price-calculation-rate"
                                        name="priceCalculationRate"
                                        type="number"
                                        disabled={!this.state.departmentDetailsSaveButtonRender || this.state.department.priceCalculationMethod == "NO_CALCULATION"}
                                        value={this.state.department.priceCalculationRate}
                                        onChange={this.__handleChange}
                                        className="form-control"
                                    />
                                </AvGroup>
                            </div>
                        </div>
                    </div>

                    <div className="settings-page__actions">
                        {GeneralUtils.checkPrivilege("post_product/department") && this.state.departmentDetailsSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.department.id) &&
                            <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                                this.setState({departmentDetailsSaveButtonRender: true});
                            }}>
                                <Translate contentKey="entity.action.add">Edit</Translate>
                            </Button>}

                        {GeneralUtils.checkPrivilege("post_product/department") && this.state.departmentDetailsSaveButtonRender &&
                            <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                                this.saveDepartment();
                            }}>
                                <Translate contentKey="entity.action.add">Save</Translate>
                            </Button>}

                        {GeneralUtils.checkPrivilege("post_product/department") && this.state.departmentDetailsSaveButtonRender &&
                            <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                                this.saveAndNextDepartment();
                            }}>
                                <Translate contentKey="entity.action.add">SaveAndNext</Translate>
                            </Button>}

                        {GeneralUtils.checkPrivilege("delete_product/department/_id/transferDepartmentId/_transferDepartmentId") && this.state.departmentDetailsSaveButtonRender == false && !GeneralUtils.isNullOrEmpty(this.state.department.id) &&
                            <Button color="outline-danger" className="settings-page__btn--delete" onClick={() => {
                                GeneralUtils.openDialogThenRef(this, {displayDialog: true}, () => this.refModelSave, (ref) => {
                                    ref.setDepartmentId(this.state.department.id);
                                });
                            }}>
                                <Translate contentKey="entity.action.add">Delete</Translate>
                            </Button>}

                        {GeneralUtils.checkPrivilege("post_product/department") && this.state.departmentDetailsSaveButtonRender &&
                            <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                                let obj1 = this.state.departmentTemp;
                                if (GeneralUtils.isNullOrEmpty(obj1.id)) {
                                    window.history.back();
                                } else {
                                    this.setState({
                                        department: Object.assign({}, obj1),
                                        departmentDetailsSaveButtonRender: false
                                    });
                                }
                            }}>
                                <Translate contentKey="entity.action.cancel">Cancel</Translate>
                            </Button>}
                    </div>
                </div>
            </div>
        );
    }

    onDataSelect = (data) => {
        this.departmentService.findById(data.id).then(response => {
            this.setState({
                department: response,
                departmentDetailsSaveButtonRender: false,
                departmentTemp: Object.assign({}, response)
            });
        });
    }

    saveAndNextDepartment = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.department.name) || GeneralUtils.isNullOrEmpty(this.state.department.tax)) {
            return toast.warn("Please fill the required fields!");
        } else if (!GeneralUtils.isNullOrEmpty(this.state.department.priceCalculationMethod) && (this.state.department.priceCalculationMethod != "NO_CALCULATION") && GeneralUtils.isNullOrEmpty(this.state.department.priceCalculationRate)) {
            return toast.warn("Please fill the rate field!");
        } else {
            if (!GeneralUtils.isNullOrEmpty(this.state.department.id)) {
                this.departmentService.update(this.state.department)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            let obj1 = Object.assign({}, defaultDepartment);
                            this.setState({
                                department: obj1,
                                departmentTemp: Object.assign({}, obj1)
                            });
                        }
                    });
            } else {
                this.departmentService.create(this.state.department)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            let obj1 = Object.assign({}, defaultDepartment);
                            this.setState({
                                department: obj1,
                                departmentTemp: Object.assign({}, obj1)
                            });
                        }
                    });
            }
        }
    }

    saveDepartment = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.department.name) || GeneralUtils.isNullOrEmpty(this.state.department.tax)) {
            return toast.warn("Please fill the required fields!");
        } else if (!GeneralUtils.isNullOrEmpty(this.state.department.priceCalculationMethod) && (this.state.department.priceCalculationMethod != "EMPTY") && GeneralUtils.isNullOrEmpty(this.state.department.priceCalculationRate)) {
            return toast.warn("Please fill the rate field!");
        } else {
            if (!GeneralUtils.isNullOrEmpty(this.state.department.id)) {
                this.departmentService.update(this.state.department)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            window.location.href = "#departmentList";
                        }
                    });
            } else {
                this.departmentService.create(this.state.department)
                    .then((response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            window.location.href = "#departmentList";
                        }
                    });
            }
        }
    }

    addNew() {
        let obj1 = Object.assign({}, defaultDepartment);
        this.setState({
            department: obj1,
            departmentDetailsSaveButtonRender: true,
            departmentTemp: Object.assign({}, obj1)
        });
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let department = this.state.department;
        department[e.target.name] = value;
        if (e.target.name == "priceCalculationMethod" && value == "EMPTY") {
            department["priceCalculationRate"] = null;
        }

        this.setState({department: department});
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }
}
